import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 12h-6","key":"svg-0"}],["path",{"d":"M5 15l-3 -3l3 -3","key":"svg-1"}],["path",{"d":"M22 12h-6","key":"svg-2"}],["path",{"d":"M19 15l3 -3l-3 -3","key":"svg-3"}],["path",{"d":"M12 4v16","key":"svg-4"}]]

const IconArrowBarBoth = createReactComponent('outline', 'arrow-bar-both', 'ArrowBarBoth', __iconNode);

export default IconArrowBarBoth;